import algoliasearch, { type SearchClient } from 'algoliasearch';

import { getBrandConfig } from '@/lib/configuration/configuration';

const buildEmptySearchResult = () => ({
  hits: [],
  nbHits: 0,
  nbPages: 0,
  page: 0,
  processingTimeMS: 0,
  hitsPerPage: 0,
  exhaustiveNbHits: false,
  query: '',
  params: '',
});

export const algoliasearchWithControl = (appId: string, apiKey: string) => {
  const client = algoliasearch(appId, apiKey);
  return {
    ...client,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    search(requests: any, requestOptions: any) {
      if (getBrandConfig().disableAlgoliaApiCall) {
        return Promise.resolve({
          results: requests.map(() => buildEmptySearchResult()),
        });
      }
      return client.search(requests, requestOptions);
    },
    initIndex(indexName: string) {
      const index = client.initIndex(indexName);
      if (getBrandConfig().disableAlgoliaApiCall) {
        return {
          ...index,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          search(query: string, requestOptions: any) {
            return Promise.resolve(buildEmptySearchResult());
          },
        };
      }
      return client.initIndex(indexName);
    },
  } as SearchClient;
};
